import { MultiSetTreeNode } from "./multi-set-tree-node";
import { Grid } from "../../graph/lib/grid";
import { Node } from "../../graph/lib/node";

/**
 * The class MultiSetWordNode extends the abstract class 
 * MultiSetTreeNode and describes the logical representation
 * of a word-node in a tree. This class implements the
 * abstract methods draw and inParameter. 
 * The method draw draws a rectangle and its content(a word) 
 * at the coordinate of the node. The method inParameter 
 * determines whether a mouse click has been performed on this 
 * rectangle or not.  
 */
export class MultiSetWordNode extends MultiSetTreeNode {

    maxWidth: number = 0;


    constructor(rowIndex: number, colIndex: number,
        id: number, content: any[], totalCount: number) {
        super(rowIndex, colIndex, id, content, totalCount);
        this.totalCount = totalCount;
        this.content = content;
    }

    setMaxWidth(maxWidth: number) {
        this.maxWidth = maxWidth;
    }

    getMaxWidth(): number {
        return this.maxWidth;
    }

    draw(ctx: CanvasRenderingContext2D, grid: Grid) {

        let center: [number, number] = grid.getCellCenter(this.rowIndex, this.colIndex);
        ctx.save();
        /*  ctx.strokeStyle = "black";
          let text: string = "[";
  
          this.content.forEach(word => {
              text = text + word + " ";
          })
  
          if (this.content.length > 0) {
              text = text.substring(0, text.length - 1);
          }
  
          text = text + "]"
          ctx.textAlign = "center";
          let textSize = 25;
  
          ctx.font = 'bold ' + textSize + 'px Arial';
          let standardWidth = 55;
  
          ctx.fillStyle = this.currentColor;
          */
        if (!this.noBox || this.content.length == 0) {
            this.drawBoxes(ctx, grid);
        }
        // ctx.fillText(text, center[0], center[1], standardWidth);
        if (!this.isHidden())
            this.drawContent(ctx, grid);
        ctx.stroke();
        ctx.fill();
        ctx.restore();
    }

    private drawBoxes(ctx: CanvasRenderingContext2D, grid: Grid) {
        let topLeft: [number, number] = grid.getUpperLeftCorner(this.rowIndex, this.colIndex);
        ctx.save();

        ctx.strokeStyle = this.currentColor;
        ctx.fillStyle = this.currentColor;

        let boxheight: number = this.boxHeight(grid);
        let offsetHeight: number = this.boxOffSetHeight(grid);
        let boxWidth: number = this.boxWidth(grid);

        for (let i = 0; i < this.totalCount; i++) {
            ctx.strokeRect(topLeft[0] + (boxWidth * i), topLeft[1] + offsetHeight, boxWidth, boxheight);
            ctx.stroke();
        }


        ctx.restore();
    }

    private boxOffSetHeight(grid: Grid): number {
        return this.boxHeight(grid) / 2;
    }

    private boxWidth(grid: Grid): number {
        let width: number = grid.getWidthCell() / this.totalCount;
        return width;
    }

    private boxHeight(grid: Grid): number {
        let boxheight: number = grid.getHeightCell() / 2;
        return boxheight;
    }

    private drawContent(ctx: CanvasRenderingContext2D, grid: Grid) {
        let topLeft: [number, number] = grid.getUpperLeftCorner(this.rowIndex, this.colIndex);
        ctx.save();
        let boxheight: number = this.boxHeight(grid);
        let offsetHeight: number = this.boxOffSetHeight(grid);
        let boxWidth: number = this.boxWidth(grid);
        let standardWidth = 55;
        let textSize = 25;
        textSize = Math.min(textSize, boxheight);
        

        let midY: number = (topLeft[1] + offsetHeight + 1 * boxheight / 2 + textSize / 2)

        for (let i = 0; i < this.content.length; i++) {
            let midX: number = (topLeft[0] + boxWidth * (i) + boxWidth / 2);

            ctx.textAlign = "center";

            ctx.strokeStyle = this.currentColor;
            ctx.fillStyle = this.currentColor;

            ctx.font = 'bold ' + textSize + 'px Arial';
            ctx.fillStyle = this.currentColor;
            ctx.fillText(this.content[i], midX, midY-1, boxWidth - 2);
            ctx.fill();
        }
        ctx.restore();
        

    }

    inParameter(e: MouseEvent, grid: Grid): boolean {
        const upperCornerLeft: [number, number] = grid.getUpperLeftCorner(this.rowIndex, this.colIndex);
        const x: number = upperCornerLeft[0];
        const y: number = upperCornerLeft[1];

        const width: number = grid.getWidthCell();
        const boxheight: number = grid.getHeightCell();

        let xInRange: boolean = (x <= e.offsetX && e.offsetX <= x + width)
        let yInRange: boolean = (y <= e.offsetY && e.offsetY <= y + boxheight);

        return xInRange && yInRange;

    }


    clone(): Node {
        let cloneNode: MultiSetWordNode = new MultiSetWordNode(this.rowIndex, this.colIndex,
            this.id, this.content, this.totalCount);
        return cloneNode;
    }
}